import { axios } from "../utils";

// refreshToken으로 accessToken을 갱신
async function silentRefresh(refreshToken) {
  try {
    const res = await axios.post("/refresh", null, {
      headers: {
        refreshToken: refreshToken,
      },
    });
    return res.data.accessToken;
  } catch (error) {
    // refreshToken이 만료됐다면 다시 로그인하게 쿠키를 삭제시킴
    document.cookie =
      "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"; // 쿠키 삭제
    console.error(error);
    window.location.href = "/login";
  }
}

export default silentRefresh;
